export default "__VITE_ASSET__DEfUMt24__"